module.exports = __webpack_public_path__ + "img/cause1Green.7a18cb10.png";